import { Box, Button, Card, CardContent, FormControl, FormGroup, Input, InputLabel, MenuItem, Paper, Select, Table, TableBody, TableCell, TableHead, TablePagination, TableRow } from '@material-ui/core';
import { ANAO, ASIM } from 'consts';
import React, { Component, useRef } from 'react';
import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';
import ClearAllIcon from '@material-ui/icons/ClearAll';
import api from '../../../services/api';
import PerfectScrollbar from 'react-perfect-scrollbar';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import PageviewOutlinedIcon from '@material-ui/icons/PageviewOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import ComboPadraoMultiple from 'views/Components/ComboPadraoMultiple';
import ComboPadrao from 'views/Components/ComboPadrao';
import { getConfigField } from 'lib/configUtils';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';

class VendedorList extends Component {
    state = {
        vendedores: [],
        searchFilter: {
            nomeVendedor: '',
            tipo: 'T',
            situacaoInativoFilter: ANAO,
            codCliente: 0
        },
        page: 0, // Página atual
        rowsPerPage: 50, // Número de itens por página
        totalItems: 0, // Total de itens para paginação
        listaClientes: []
    };

    estilo = {
        marginLeft: 30,
        marginTop: 30,
        marginRight: 30,
        container: {
            display: 'flex',
            justifyContent: 'flex-end',
        },
        addButton: {
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            float: 'right', // alinhamento a direita
            marginTop: 3,
            marginRight: 3
        },
        redText: {
            color: 'red',
        },
    };

    constructor(props) {
        super(props);
    }

    /* carregamento inicial */
    async componentDidMount() {
        const clientes = await api.get(`/cliente/active/true`);
        this.setState({ listaClientes: clientes.data });

        this.loadVendedores();
    }

    /* Carrega vendedores */
    loadVendedores = async () => {
        const { searchFilter, page, rowsPerPage } = this.state;

        let params = `?page=${page + 1}&limit=${rowsPerPage}`;

        /* consulta pelo nome do vendedor */
        if (!(searchFilter.nomeVendedor === '')) {
            params += '&tbvendedor.nomevendedor=_like_' + searchFilter.nomeVendedor
        }

        /* filtra tipo vendedor */
        switch (searchFilter.tipo) {
            case 'E':
                params += '&tipo=E'
                break;
            case 'I':
                params += '&tipo=I'
                break;
            default:
                break;
        }

        /* filtra situação do vendedor */
        switch (searchFilter.situacaoInativoFilter) {
            case ASIM:
                params += '&tbvendedor.inativo=' + ASIM
                break;
            case ANAO:
                params += '&tbvendedor.inativo=' + ANAO
                break;
            default:
                break;
        }

        /* filtra pelo cliente vinculado */
        if (!(searchFilter.codCliente == 0 || searchFilter.codCliente == 'undefined')) {
            params += '&tbvendedor.codcliente=' + searchFilter.codCliente
        }

        params += '&sort=nomevendedor';

        const response = await api.get('/vendedor' + params);
        this.setState({
            vendedores: response.data.data,
            totalItems: parseInt(response.data.info['totalrecords'], 10) || 0
        });
    }

    /* Escolha de uma conta para exclusão */
    handleSelectItem = (id) => {
        this.setState({ selectedId: id });
    };

    /* deleta vendedor */
    handleDelete = async (id) => {
        try {
            const response = await api.delete(`/vendedor/${id}`);
            // Verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleClose();
                this.loadVendedores();
            }
        } catch (error) {
            this.handleClose();
            this.handleOpenAlert(error.response.data.error);
            console.log(error);
            console.log(error.message);
        }
    };

    /* abre janela confirmação para exclusão */
    handleOpen = (codservico) => {
        this.setState({ open: true });
        this.handleSelectItem(codservico);
    };

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela de confirmação exclusão */
    handleClose = () => {
        this.setState({ open: false });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    }

    /* Pesquisar filtros na tela */
    OnChangeSearch = (event) => {
        const { searchFilter } = this.state;
        let { name, value } = event.target;
        if (!(name == 'codCliente')) {
            value = value.toUpperCase()
        }
        searchFilter[name] = value;

        this.setState({ searchFilter: searchFilter });
        if (name === 'situacaoInativoFilter') {
            this.loadVendedores();
        }
    };

    /* Limpa Filtros na tela */
    LimpaFiltros = () => {
        let { searchFilter } = this.state;

        searchFilter.nomeVendedor = '';
        searchFilter.tipo = 'T';
        searchFilter.situacaoInativoFilter = ANAO;
        searchFilter.codCliente = 0;

        this.setState({ searchFilter: searchFilter });
    }

    handleSearch = () => {
        let errors = this.validationRequiredFields();

        if (!(errors === '')) {
            this.handleOpenAlert(errors);
        } else {
            this.loadVendedores();
        }
    };

    validationRequiredFields = () => {
        const { searchFilter } = this.state;
        let errors = '';

        return errors;
    };

    /* Mudança de página */
    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage }, () => {
            this.loadVendedores();
        });
    };

    /* Mudança na quantidade de linhas por página */
    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, () => {
            this.loadVendedores();
        });
    };

    render() {
        const { vendedores, searchFilter, page, rowsPerPage, totalItems } = this.state;
        const { listaClientes } = this.state;

        // campos configurações
        const possibvincvendedorcliente = (getConfigField('possibvincvendedorcliente') == ASIM);

        return (
            <div style={this.estilo}>
                <Button
                    component={Link}
                    to="/front/vendedores/novo"
                    variant="contained"
                    color="primary"
                    style={this.estilo.addButton}
                >
                    Novo
                </Button>

                <Paper
                    hover
                    size
                    style={{ marginBottom: 10, marginTop: 10 }}
                >
                    <FormGroup row>
                        <Input
                            autoFocus
                            id="nomeVendedor"
                            name="nomeVendedor"
                            onChange={this.OnChangeSearch}
                            placeholder="Nome vendedor a pesquisar"
                            style={{ marginBottom: 5, width: 300, marginLeft: 10, marginTop: 10, marginRight: 10 }}
                            value={searchFilter.nomeVendedor}
                        />

                        <FormControl
                            style={{ marginBottom: 5, marginRight: 10, marginLeft: 10 }}
                        >
                            <InputLabel id="input-label">Tipo</InputLabel>
                            <Select
                                id="tipo"
                                name="tipo"
                                value={searchFilter.tipo || ''}
                                onChange={this.OnChangeSearch}
                            // style={{ marginLeft: 20 }}
                            >
                                <MenuItem value={'T'}>Todos</MenuItem>
                                <MenuItem value={'I'}>Interno</MenuItem>
                                <MenuItem value={'E'}>Externo</MenuItem>
                            </Select>
                        </FormControl>

                        <Select
                            id="situacaoInativoFilter"
                            name="situacaoInativoFilter"
                            value={searchFilter.situacaoInativoFilter || ''}
                            onChange={this.OnChangeSearch}
                            style={{ marginBottom: 5, marginTop: 15, marginRight: 10, marginLeft: 10 }}
                        >
                            <MenuItem value={ANAO}>Ativos</MenuItem>
                            <MenuItem value={ASIM}>Inativos</MenuItem>
                            <MenuItem value={'T'}>Todos</MenuItem>
                        </Select>

                        <Button
                            color="primary"
                            id="pesquisar"
                            onClick={this.handleSearch}
                        >
                            <SearchIcon />
                        </Button>

                        <Button
                            color="primary"
                            onClick={() => this.LimpaFiltros()}
                        >
                            <ClearAllIcon />
                        </Button>
                    </FormGroup>
                </Paper>

                <Paper
                    hover
                    size
                    style={{ marginBottom: 10, marginTop: 10 }}
                >
                    <Box
                        style={{ marginLeft: 10, width: 300 }}
                    >
                        {possibvincvendedorcliente && (
                            <FormControl
                                fullWidth
                                style={{ marginRight: '10px', marginTop: 5 }}
                                // variant="outlined"
                                disabled={this.state.isView}
                            >
                                <InputLabel htmlFor="outlined-age-native-simple">Cliente</InputLabel>

                                <ComboPadrao
                                    name={'codCliente'}
                                    label={'Cliente'}
                                    value={searchFilter.codCliente}
                                    onChange={this.OnChangeSearch}
                                    fieldId={'codcliente'}
                                    listItems={listaClientes}
                                    fieldDescription={'fantasia'}
                                    height={25}
                                />

                            </FormControl>)
                        }
                    </Box>
                </Paper>

                <Card>
                    <CardContent>
                        <PerfectScrollbar>
                            <div >
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Código</TableCell>
                                            <TableCell>Nome</TableCell>
                                            <TableCell>Tipo</TableCell>
                                            <TableCell>Ações</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {vendedores.slice(0, 1000).map(vendedor => (
                                            <TableRow
                                                hover
                                                key={vendedor.codvendedor}
                                            >
                                                <TableCell style={(vendedor.inativo === ASIM) ? this.estilo.redText : {}}>{vendedor.codvendedor}</TableCell>

                                                <TableCell style={(vendedor.inativo === ASIM) ? this.estilo.redText : {}} >{vendedor.nomevendedor}</TableCell>

                                                <TableCell style={(vendedor.inativo === ASIM) ? this.estilo.redText : {}} >
                                                    {((vendedor.vendedorexterno == ASIM) ? 'Externo' : 'Interno')}
                                                </TableCell>

                                                <TableCell>
                                                    <Link to={`/front/vendedores/${vendedor.codvendedor}`}>
                                                        <EditOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <Link to={`/front/vendedores/${vendedor.codvendedor}/view`}>
                                                        <PageviewOutlinedIcon style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                    </Link>
                                                    <DeleteForeverOutlinedIcon
                                                        onClick={() => this.handleOpen(vendedor.codvendedor)}
                                                        style={{ cursor: 'pointer', marginRight: '10px' }} />
                                                </TableCell>

                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </div>
                        </PerfectScrollbar>
                    </CardContent>
                </Card>

                <TablePagination
                    component="div"
                    labelRowsPerPage={'Registros por página'}
                    rowsPerPageOptions={[50, 100, 150]}
                    count={totalItems}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                    labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
                    }
                />

                <DeleteConfirmationModal
                    open={this.state.open}
                    handleClose={() => this.handleClose()}
                    itemId={this.state.selectedId}
                    message={"Confirma exclusão do vendedor " + this.state.selectedId + '?'}
                    handleDelete={() => this.handleDelete(this.state.selectedId)}
                />

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />
            </div>
        );
    }
}

export default VendedorList;